// import loadingData from './loading.json'

var $
var ua
let uid = 1

class Progress {
  constructor (config) {
    if (process.browser) {
      $ = require('zepto')
      ua = require('ua')
    } else {
      return
    }
    config = this.config = config || {}
    this.overlay = $('<div class="overlay" />')
    this.progress = $('<div class="pn-loading">加载中...</div>')

    let $spin = $('<div class="spin" />')

    this.appended = false

    if (config.zIndex) {
      this.progress.css('z-index', config.zIndex)
			this.overlay.css('z-index', Math.abs(config.zIndex - 1))
    }

    this.progress.attr('data-id', uid)

    this.spin = $spin
    uid++
  }
  _appendElements () {
    let $body = $('body')

    if (!this.appended) {
      this.progress.hide().appendTo($body)
      // this.aniProgress.hide().appendTo($body)
      if (this.config.hasOverlay) {
        this.overlay.hide().appendTo($body)
      }
      this.appended = true
    }
  }
  showMessage (message, stick, hideTime) {
    if (!message) return
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this._appendElements()

    return new Promise((resolve) => {
      if (message.constructor == Error) {
        message = message.message
      }
      if (typeof message === 'string') {
        this.progress.text(message)
      } else if (message.icon && message.text) {
        this.progress.html(`<img style="width: 28px;" src="${message.icon}" /><div style="padding: 0 15px">${message.text}</div>`)
      }
      this.progress.show()
      if (!stick) {
        this.timeout = setTimeout(() => {
          this.hide()
          resolve()
        }, hideTime || 1000)
      }
      this.progress.css('left', 0)
      this.progress.css('margin-left', 0)
      this.progress.css('margin-left', -this.progress.width() / 2)
      this.progress.css('left', '50%')
      this.progress.css('margin-top', -this.progress.height() / 2)
    })
  }
  showProgress (text = '') {
    if (ua.isWanda()) { return }
    this._appendElements()

    this.overlay && this.overlay.show()
    this.progress.text(text ||'加载中...')
    this.progress.show()
  }
  hide () {
    this.overlay && this.overlay.hide()
    this.progress.hide()
    // this.aniProgress.hide()
  }
}

let shared = Progress.shared = new Progress()
export default Progress
export { shared }



// WEBPACK FOOTER //
// ./src/mods/progress.js